import React from 'react'

type Line = {
  from: [number, number]
  to: [number, number]
  midpoint: [number, number]
}

type Props = {
  lines?: Line[]
}

function ConnectionLinesOverlay({ lines }: Props) {
  if (!lines) return null

  return (
    <svg
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 1,
      }}
    >
      {lines.map(({ from, to, midpoint }, idx) => (
        <g key={idx}>
          <line
            strokeWidth={2}
            x1={from[0]}
            x2={to[0]}
            y1={from[1]}
            y2={to[1]}
          />
          <circle cx={midpoint[0]} cy={midpoint[1]} r={6} />
        </g>
      ))}
    </svg>
  )
}

export default ConnectionLinesOverlay
